import React, { useEffect } from 'react'
import { useState } from 'react'

export default function useLocalStorage(itemKey: string, defaultValue: any) {
  const [value, setvalue] = useState(() => {
    const item = window.localStorage.getItem(itemKey)
    if (item !== null) return JSON.parse(item)
    else return defaultValue
  })
  useEffect(() => {
    localStorage.setItem(itemKey,JSON.stringify(value))
  }, [value])
  
  
  return [value,setvalue] as const
}

